module.exports = __webpack_public_path__ + "static/media/Diabetes-research-group-ES-4.3638f101.jpg";